import { AnyAction, applyMiddleware, createStore, Middleware } from 'redux';
import storeLoggerMiddleware from 'redux-logger';

import { mockMiddleware } from './MockMiddleware';
import RootReducer from './RootReducer';
import { sagaMiddleware, startSagasWorkers } from './SagasProvider';
import { getComposeEnhancers } from './StoreExtensionSupporter';
import { isDevelopmentEnv, isTestEnv } from '../devOpsHelper/DevOps';
import { logErrorMiddleware } from '../iwLogger/LogErrorMiddleware';

type Store = ReturnType<typeof configureStore>;
export type RootState = ReturnType<Store['getState']>;

// eslint-disable-next-line import/no-default-export
export default function configureStore(
    initialState?: Partial<ReturnType<typeof RootReducer>>
) {
    const composeEnhancers = getComposeEnhancers();
    const middlewares = getMiddlewares();
    const enhancer = composeEnhancers(applyMiddleware(...middlewares));
    // @ts-expect-error
    const store = createStore(RootReducer, initialState, enhancer);

    startSagasWorkers();

    storeHandler.store = store;
    return store;
}

function getMiddlewares() {
    const middlewares: Middleware[] = [logErrorMiddleware, sagaMiddleware];

    if (
        isDevelopmentEnv() &&
        process.env.REACT_APP_DISABLE_REDUX_ACTION_CONSOLE_LOGS !== 'true'
    ) {
        middlewares.push(storeLoggerMiddleware);
    } else if (isTestEnv()) {
        middlewares.push(mockMiddleware);
    }

    return middlewares;
}

export const storeHandler: { store: Store } = {
    // @ts-expect-error
    store: {}
};
export function resetStoreValue(storeValue: Store | object) {
    // @ts-expect-error
    storeHandler.store = storeValue;
}

export function getStoreState(): RootState {
    if (storeHandler.store.getState) {
        return storeHandler.store.getState();
    }

    // @ts-expect-error
    return storeHandler.store;
}

export function storeDispatch(dispatchObject: AnyAction) {
    storeHandler.store.dispatch(dispatchObject);
}
